var map = {
	"./arrow-down.svg": "f66a",
	"./arrow-left.svg": "51b5",
	"./arrow-left2.svg": "e6d1",
	"./arrow-right2.svg": "3a84",
	"./book.svg": "cda0",
	"./close.svg": "864a",
	"./closed.svg": "db4b",
	"./edit-note.svg": "3563",
	"./exit.svg": "a109",
	"./eyee.svg": "5975",
	"./house.svg": "e6a3",
	"./info.svg": "b888",
	"./life.svg": "995e",
	"./logo.svg": "d9b6",
	"./ok.svg": "5f44",
	"./open-book.svg": "39b3",
	"./organization.svg": "2347",
	"./plus.svg": "701f",
	"./sort-asc.svg": "bba7",
	"./sort-desc.svg": "bf54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a601";